<template>
  <div class="wrap">
    <div class="header">
      <div class="logo">spharos</div>
      <div class="box-gray hdr-info">
        <span class="dt">매장명</span>
        <span class="dd ellipsis">회현점</span>
        <span class="dt">포스번호</span>
        <span class="dd">POS-001</span>
        <span class="dt">사용자</span>
        <span class="dd">홍길동</span>
        <span class="dt">영업일자</span>
        <span class="dd">2023-12-05</span>
      </div>
      <!-- 붉은 와이파이: 아래 요소에 off 클래스 추가 -->

      <button
        type="button"
        class="btn-sm btn-yellow"
        :class="{ disabled: isToggle1 }"
        @click="isToggle1 ? (isToggle1 = false) : (isToggle1 = true)"
      >
        <i class="icon ico-print"></i>영수증<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-sm btn-yellow"
        :class="{ disabled: isToggle2 }"
        @click="isToggle2 ? (isToggle2 = false) : (isToggle2 = true)"
      >
        <i class="icon ico-print"></i>주방<span class="overlay"></span>
      </button>
      <button type="button" class="btn-close" @click="this.$router.push('/')">
        닫기<span class="overlay"></span>
      </button>
      <span class="icon ico-wifi"></span>
    </div>
    <div class="content">
      <div class="tab-area">
        <button class="btn-prev" @click="this.scrollMove(-160)">
          <span class="overlay"></span>
        </button>
        <div
          class="tab non-scroll"
          id="tableGroupScroll"
          style="overflow: auto"
        >
          <button
            v-for="grp in tableGroupList"
            :key="grp"
            tyle="button"
            class="btn-tab"
            style="min-width: 120px"
            :class="{ on: selectGrpIdx == grp.tableGroupIdx }"
            @click="selectGrpIdx = grp.tableGroupIdx"
          >
            {{ grp.name }}
          </button>
        </div>
        <button class="btn-next" @click="this.scrollMove(160)">
          <span class="overlay"></span>
        </button>
      </div>
      <div class="main">
        <!-- one item (.table-box) -->
        <!-- [클래스명] 1행1열 ~ 3행5열: .mt-r1c1 ~ .mt-r3c5 , 파란헤더: .mt-menu, 주황헤더: .mt-time -->

        <!-- 20231107 아이콘 정의: 아래 요소(span.ico-mt)에 클래스 명 수정 
                            mt01: 4인테이블,
                            mt02: 2인테이블,
                            mt03: 캐셔,
                            mt04: 주방,
                            mt05: 화장실,
                            mt06: 식물,
                            mt07: 문,
                            mt08: 계단,
                            mt09: 파티션
                        -->
        <div
          v-for="table in tableList.filter(
            (item) => item.tableGroupIdx == selectGrpIdx
          )"
          :key="table"
          class="main-table"
          :class="[
            `mt-r${table.row}c${table.col}`,
            { disabled: isMove && table == firstTable },
            table.code == 'mt01' || table.code == 'mt02'
              ? 'mt-menu'
              : 'mt-base',
          ]"
          @click="tableClick(table)"
        >
          <div
            class="mt-header"
            v-if="table.code == 'mt01' || table.code == 'mt02'"
          >
            <span class="tb-name">{{ table.name }}</span>
            <span v-if="isMenuInfo">{{
              prodPrice(
                orderList.filter((item) => item.tableIdx == table.tableIdx)
              )
            }}</span>
            <span v-else>
              {{
                orderList.filter((item) => item.tableIdx == table.tableIdx)
                  .length == 0
                  ? 0
                  : orderList.filter(
                      (item) => item.tableIdx == table.tableIdx
                    )[0].personnel
              }}
              명
            </span>
          </div>
          <div class="mt-body">
            <span
              v-if="
                orderList.filter((item) => item.tableIdx == table.tableIdx)
                  .length == 0
              "
              class="ico-mt"
              :class="
                table.code == 'mt02' || table.code == 'mt01' ? '' : table.code
              "
            ></span>
            <span v-else-if="isTableInfo" class="posi-center">
              {{
                orderList
                  .filter((item) => item.tableIdx == table.tableIdx)
                  .map((item) => item.startTime)[0]
              }}
              <br />{{
                dateSub(
                  orderList
                    .filter((item) => item.tableIdx == table.tableIdx)
                    .map((item) => item.startTime)[0]
                )
              }}
            </span>
            <ul v-else-if="isMenuInfo" class="mt-lst lst-menu no-ft">
              <li
                v-for="menu in orderList
                  .filter((item) => item.tableIdx == table.tableIdx)
                  .map((item) => item.menuArr)[0]"
                :key="menu"
              >
                <span class="dt">{{ menu.name }}</span>
                <span class="dd">{{ menu.qty }}</span>
              </li>
            </ul>
            <!-- 기본 화면 -->
            <ul v-else class="mt-lst lst-order no-ft">
              <li>
                <span class="dt">고객수</span>
                <span class="dd">{{
                  orderList
                    .filter((item) => item.tableIdx == table.tableIdx)
                    .map((item) => item.personnel)[0]
                }}</span>
              </li>
              <li>
                <span class="dt">주문시간</span>
                <span class="dd">{{
                  orderList
                    .filter((item) => item.tableIdx == table.tableIdx)
                    .map((item) => item.startTime)[0]
                }}</span>
              </li>
              <li>
                <span class="dt">주문수량</span>
                <span class="dd">{{
                  orderList
                    .filter((item) => item.tableIdx == table.tableIdx)
                    .map((item) => item.menuArr)[0].length
                }}</span>
              </li>
            </ul>
            <div v-if="isTableInfo" class="mt-footer center">
              {{ getOrdererCode(table) }}
            </div>
          </div>
        </div>

        <!-- // one item -->
      </div>
      <div class="side-btn-area">
        <button
          type="button"
          class="btn-side btn-yellow"
          :class="{ selected: isMove }"
          @click="
            isMove
              ? ((isMove = false), (firstTable = null), (secondTable = null))
              : (isMove = true)
          "
        >
          이동<span class="overlay"></span>
        </button>
        <button
          :class="{ selected: isPrint }"
          @click="isPrint ? (isPrint = false) : (isPrint = true)"
          type="button"
          class="btn-side btn-yellow"
        >
          재출력<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-side btn-yellow"
          :class="{ selected: isIntbill }"
          @click="isIntbill ? (isIntbill = false) : (isIntbill = true)"
        >
          중간 계산서<span class="overlay"></span>
        </button>
        <button type="button" class="btn-side btn-yellow">
          환전<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-side btn-yellow"
          :class="{ selected: isMenuInfo }"
          @click="
            isMenuInfo
              ? ((isMenuInfo = false), (isTableInfo = true))
              : ((isTableInfo = false), (isMenuInfo = true))
          "
        >
          메뉴<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-side btn-yellow"
          :class="{ selected: isReceipt }"
          @click="receiptPrint()"
        >
          직전 영수증<span class="overlay"></span>
        </button>
        <button type="button" class="btn-side btn-yellow" @click="tableReceipt">
          영수증 관리<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-side btn-yellow"
          :class="{ selected: isPrebill }"
          @click="isPrebill ? (isPrebill = false) : (isPrebill = true)"
        >
          선결제<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-side btn-yellow"
          :class="{ selected: isComplete }"
          @click="isComplete ? (isComplete = false) : (isComplete = true)"
        >
          완료처리<span class="overlay"></span>
        </button>
        <!-- <button
          type="button"
          class="btn-side btn-yellow"
          :class="{ on: isTableInfo }"
          @click="
            isTableInfo
              ? (isTableInfo = false)
              : ((isMenuInfo = false), (isTableInfo = true))
          "
        >
          테이블 정보<span class="overlay"></span>
        </button> -->
      </div>
    </div>

    <PopupBtn1
      v-if="isPopupBtn1"
      :popupText="popupText"
      :popupTitle="popupTitle"
      @close="isPopupBtn1 = false"
    />

    <PopupBtn2
      v-if="isPopupBtn2"
      :popupText="popupText"
      :popupTitle="popupTitle"
      @close="isPopupBtn2 = false"
      @setYes="setYes"
    />

    <PopupBtnList
      v-if="isPopupBtnList"
      :btnList="btnList"
      :popupTitle="popupTitle"
      @close="isPopupBtnList = false"
      @setBtn="setBtn"
    />

    <AdvancePayment
      v-if="isPayment"
      @complete="advancePaymentComplete"
      @close="isPayment = false"
    />

    <OrdererSelect
      v-if="isOrdererSelect"
      :selectOrder="selectOrder"
      @setSelectOrderer="setSelectOrderer"
      @close="isOrdererSelect = false"
    />

    <CustomerManagement
      v-if="isCustomerManagement"
      @close="isCustomerManagement = false"
      @tableSetBaskets="tableSetBaskets"
    />
  </div>
</template>

<script>
//component
import popupBtn1 from "@/components/popup/PopupBtn1.vue";
import popupBtn2 from "@/components/popup/PopupBtn2.vue";
import popupBtnList from "@/components/popup/PopupBtnList.vue";
import advancePayment from "@/components/popup/AdvancePayment.vue";
import ordererSelect from "@/views/modal/OrdererSelect.vue";
import customerManagement from "@/views/modal/CustomerManagement.vue";

export default {
  name: "orderTable",
  props: {},
  data() {
    return {
      tableGroupList: this.$store.getters.getTableGroupList,
      tableList: this.$store.getters.getTableList,
      orderList: this.$store.getters.getOrderList,
      menuList: this.$store.getters.getMenuList,
      selectGrpIdx: this.$store.getters.getTableGroupList[0].tableGroupIdx,
      isTableInfo: true,
      isMenuInfo: false,
      isMove: false,
      firstTable: null,
      secondTable: null,
      firstOrder: null,
      secondOrder: null,
      isPopupBtn1: false,
      isPopupBtn2: false,
      isPopupBtnList: false,
      btnList: [
        { name: "고객주문서", idx: 1 },
        { name: "주방주문서", idx: 2 },
      ],
      popupText: "",
      popupTitle: "",
      isPrint: false,
      isPrebill: false,
      isIntbill: false,
      isComplete: false,
      isReceipt: false,
      isPayment: false,
      isOrdererSelect: false,
      selectOrder: null,
      selectTable: null,
      isCustomerManagement: false,
      ordererIdx: 0,
      isToggle1: false,
      isToggle2: false,
      ordererList: [
        { idx: 1, name: "점장", code: "0001" },
        { idx: 2, name: "직원", code: "0002" },
      ],
    };
  },
  methods: {
    getOrdererCode(table) {
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length != 0
      ) {
        var idx = this.orderList.filter(
          (item) => item.tableIdx == table.tableIdx
        )[0].ordererIdx;
        return this.ordererList.filter((item) => item.idx == idx)[0].code;
      } else return "";
    },
    advancePaymentComplete(amt) {
      let menuArr = this.firstOrder.menuArr;
      let sum = 0;

      menuArr.forEach((menu) => {
        let price = this.menuList
          .filter((item) => item.menuIdx == menu.menuIdx)
          .map((item) => item.price)[0];
        sum += menu.qty * price;
      });

      if (sum - this.firstOrder.receivedUprc < Number(amt)) {
        this.popupTitle = "선결제";
        this.popupText = "입력된 금액이 결제 금액보다 큽니다.";
        this.isPopupBtn1 = true;
      } else {
        this.firstOrder.receivedUprc += Number(amt);

        this.popupTitle = "선결제";
        this.popupText = "선결제 되었습니다.";
        this.isPopupBtn1 = true;
        this.isPrebill = false;
        this.isPayment = false;
      }
    },
    tableClick(table) {
      if (table.code != "mt01" && table.code != "mt02") return;

      if (this.isMove) this.tableMove(table); //합석 & 이동
      else if (this.isPrint) this.tablePrint(table); //재출력
      else if (this.isIntbill) this.tableIntbill(table); //중간 계산서
      else if (this.isPrebill) this.tablePrebill(table); //선결제
      else if (this.isComplete) this.tableComplete(table); //완료처리
      else if (this.isReceipt) this.tableReceiptDetail(table); //영수증
      else this.setOrderer(table);
    },
    //영수증 관리
    tableReceipt() {
      this.$store.dispatch("setBaskets", null);
      this.$router.push({ name: "order-main", params: { receiptYn: "Y" } });
    },
    //영수증 상세
    tableReceiptDetail(table) {
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length == 0
      )
        return;

      let order = this.orderList.filter(
        (item) => item.tableIdx == table.tableIdx
      )[0];

      this.$store.dispatch("setBaskets", order);
      this.$router.push({ name: "order-main", params: { receiptYn: "Y" } });
    },
    //주문자 선택
    setOrderer(table) {
      this.selectTable = table;
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length != 0
      ) {
        this.selectOrder = this.orderList.filter(
          (item) => item.tableIdx == table.tableIdx
        )[0];
      } else {
        this.selectOrder = null;
      }

      this.isOrdererSelect = true;
    },
    setSelectOrderer(ordererIdx) {
      this.isOrdererSelect = false;
      this.ordererIdx = ordererIdx;
      let order;
      if (
        this.orderList.filter(
          (item) => item.tableIdx == this.selectTable.tableIdx
        ).length != 0
      ) {
        this.tableSetBaskets();
      } else {
        this.isCustomerManagement = true;
      }

      //this.tableSetBaskets(ordererIdx);
    },
    //장바구니 담고 화면 이동
    tableSetBaskets(selectCustomerList) {
      let order;
      if (
        this.orderList.filter(
          (item) => item.tableIdx == this.selectTable.tableIdx
        ).length != 0
      ) {
        order = this.orderList.filter(
          (item) => item.tableIdx == this.selectTable.tableIdx
        )[0];
        order.ordererIdx = this.ordererIdx;
      } else {
        let idx = Math.max(...this.orderList.map((item) => item.orderIdx));
        let sum = 0;
        selectCustomerList.forEach((item) => {
          sum += Number(item.custNum);
        });
        order = {
          menuArr: [],
          name: "게스트",
          orderIdx: ++idx,
          personnel: sum,
          startTime: "",
          tableIdx: this.selectTable.tableIdx,
          receivedUprc: 0,
          ordererIdx: this.ordererIdx,
        };
      }

      this.$store.dispatch("setBaskets", order);

      //this.$router.push("/order/main");
      this.$router.push({ name: "order-main-table", params: { tableYn: "Y" } });
    },
    //완료처리
    tableComplete(table) {
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length == 0
      )
        return;
      let filteredArray = this.orderList.filter(
        (item) => item.tableIdx != table.tableIdx
      );

      let salesList = this.$store.getters.getSalesList;
      let receiptList = this.$store.getters.getReceiptList;
      let idx = Math.max(...salesList.map((item) => item.salesIdx));
      let idx2 = Math.max(...receiptList.map((item) => item.receiptIdx));

      let order = this.orderList.filter(
        (item) => item.tableIdx == table.tableIdx
      )[0];

      let today = new Date();
      let year = today.getFullYear(); // 년도
      let month = today.getMonth() + 1; // 월
      let date = today.getDate(); // 날짜

      let h = today.getHours();
      let m = today.getMinutes();
      let s = today.getSeconds();
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;

      let sale = {
        salesIdx: ++idx,
        orderIdx: order.orderIdx,
        name: order.name,
        personnel: order.personnel,
        menuArr: order.menuArr,
        salesDate: year + "-" + month + "-" + date,
        salesTime: h + ":" + m + ":" + s,
      };
      salesList.push(sale);

      let amount = 0;
      order.menuArr.forEach((item) => {
        amount += item.price;
      });

      let receipt = {
        receiptIdx: ++idx2,
        salesIdx: sale.salesIdx,
        receiptDate: sale.salesDate,
        receiptTime: sale.salesTime,
        posNo: "0001",
        amount: amount,
        type: "RCP001", // 001 정상 002 반품
        receiptNo: "17004620",
        payType: "PAY001", //001 신카 002 현금
        desc: JSON.stringify(salesList),
      };
      receiptList.push(receipt);

      this.$store.dispatch("setReceiptList", receiptList);
      this.$store.dispatch("setSalesList", salesList);

      this.orderList = filteredArray;
      this.$store.dispatch("setOrderList", filteredArray);

      this.popupTitle = "완료처리";
      this.popupText = table.name + " 테이블이 완료처리 되었습니다.";
      this.isPopupBtn1 = true;
      this.isComplete = false;
    },
    //선결제
    tablePrebill(table) {
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length == 0
      )
        return;

      this.firstTable = table;
      this.firstOrder = this.orderList.filter(
        (item) => item.tableIdx == table.tableIdx
      )[0];
      this.isPayment = true;
    },
    //중간 계산서
    tableIntbill(table) {
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length == 0
      )
        return;

      this.popupTitle = "중간계산서";
      this.popupText = "중간계산 되었습니다.";
      this.isPopupBtn1 = true;
      this.isIntbill = false;
    },
    //재출력
    tablePrint(table) {
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length == 0
      )
        return;

      this.popupTitle = "재출력";
      this.isPopupBtnList = true;
    },
    setBtn(idx) {
      this.isPopupBtnList = false;
      let txt = idx == 1 ? "고객주문서" : "주방주문서";
      this.popupTitle = "재출력";
      this.popupText = txt + "가 재출력되었습니다.";
      this.isPopupBtn1 = true;
      this.isPrint = false;
    },
    //합석
    tableMove(table) {
      if (
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length == 0 &&
        this.firstTable == null
      )
        return;

      if (this.firstTable == null) {
        this.firstTable = table;
        this.firstOrder = this.orderList.filter(
          (item) => item.tableIdx == table.tableIdx
        )[0];
      } else if (this.firstTable.tableIdx == table.tableIdx) {
        return;
      } else if (
        this.secondTable == null &&
        this.orderList.filter((item) => item.tableIdx == table.tableIdx)
          .length != 0
      ) {
        //테이블 합석
        this.secondTable = table;
        this.secondOrder = this.orderList.filter(
          (item) => item.tableIdx == table.tableIdx
        )[0];

        let mergedArray = this.firstOrder.menuArr
          .concat(this.secondOrder.menuArr)
          .reduce((acc, cur) => {
            let found = acc.find((element) => element.menuIdx === cur.menuIdx);
            if (found) {
              found.qty = found.qty + cur.qty;
            } else {
              acc.push(cur);
            }
            return acc;
          }, []);

        let sumOrder = {
          name: this.secondOrder.name + " & " + this.firstOrder.name,
          orderIdx: this.secondOrder.orderIdx,
          personnel: this.secondOrder.personnel + this.firstOrder.personnel,
          startTime: this.secondOrder.startTime,
          tableIdx: this.secondOrder.tableIdx,
          menuArr: mergedArray,
        };

        this.orderList.map((item) => {
          if (item.orderIdx == sumOrder.orderIdx) {
            Object.assign(item, sumOrder);
          }
        });

        let filteredArray = this.orderList.filter(
          (item) => item.orderIdx != this.firstOrder.orderIdx
        );

        this.orderList = filteredArray;
        this.$store.dispatch("setOrderList", filteredArray);
        this.isMove = false;
        this.firstTable = null;
        this.secondTable = null;
        this.firstOrder = null;
        this.secondOrder = null;

        this.popupTitle = "테이블 합석";
        this.popupText = "테이블이 합석되었습니다.";
        this.isPopupBtn1 = true;
      } else {
        //테이블 이동
        this.firstOrder.tableIdx = table.tableIdx;

        this.orderList.map((item) => {
          if (item.orderIdx == this.firstOrder.orderIdx) {
            Object.assign(item, this.firstOrder);
          }
        });

        this.$store.dispatch("setOrderList", this.orderList);
        this.isMove = false;
        this.firstTable = null;
        this.secondTable = null;
        this.firstOrder = null;
        this.secondOrder = null;

        this.popupTitle = "테이블 이동";
        this.popupText = "테이블이 이동되었습니다.";
        this.isPopupBtn1 = true;
      }
    },
    prodPrice(order) {
      let menuArr = order.map((item) => item.menuArr)[0];
      if (typeof order == "undefined") return 0;
      if (typeof menuArr == "undefined") return 0;
      let receivedUprc = order.map((item) => item.receivedUprc)[0];
      receivedUprc = typeof receivedUprc == "undefined" ? 0 : receivedUprc;
      let sum = 0;

      if (menuArr.length == 0) return 0;
      menuArr.forEach((menu) => {
        let price = this.menuList
          .filter((item) => item.menuIdx == menu.menuIdx)
          .map((item) => item.price)[0];
        sum += menu.qty * price;
      });
      return (sum - receivedUprc)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    dateSub(startTime) {
      if (startTime == null || startTime == "") return;
      let today = new Date();
      let hours = today.getHours();
      let minutes = today.getMinutes();

      let time1 = Number(hours) * 60 + Number(minutes);
      let time2 =
        Number(startTime.split(":")[0]) * 60 + Number(startTime.split(":")[1]);

      let timeSub = time1 - time2;
      let h = Math.floor(timeSub / 60);
      let m = Math.ceil(timeSub % 60);

      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;

      return h + ":" + m;
    },
    scrollMove(moveX) {
      var scroll = document.getElementById("tableGroupScroll");
      // bscroll.scrollTop += moveY;
      scroll.scrollTo({ left: scroll.scrollLeft + moveX, behavior: "smooth" });
    },
    receiptPrint(){
      this.popupTitle = "직전영수증";
      this.popupText = "직전영수증이 출력되었습니다.";
      this.isPopupBtn1 = true;
    }
  },
  watch: {
    isMove(val) {
      if (val) {
        this.isPrint = false;
        this.isPrebill = false;
        this.isIntbill = false;
        this.isComplete = false;
        this.isReceipt = false;
      }
    },
    isPrint(val) {
      if (val) {
        this.isMove = false;
        this.isPrebill = false;
        this.isIntbill = false;
        this.isComplete = false;
        this.isReceipt = false;
      }
    },
    isPrebill(val) {
      if (val) {
        this.isMove = false;
        this.isPrint = false;
        this.isIntbill = false;
        this.isComplete = false;
        this.isReceipt = false;
      }
    },
    isIntbill(val) {
      if (val) {
        this.isMove = false;
        this.isPrint = false;
        this.isPrebill = false;
        this.isComplete = false;
        this.isReceipt = false;
      }
    },
    isComplete(val) {
      if (val) {
        this.isMove = false;
        this.isPrint = false;
        this.isPrebill = false;
        this.isIntbill = false;
        this.isReceipt = false;
      }
    },
    isReceipt(val) {
      if (val) {
        this.isMove = false;
        this.isPrint = false;
        this.isPrebill = false;
        this.isIntbill = false;
        this.isComplete = false;
      }
    },
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {
    PopupBtn1: popupBtn1,
    PopupBtn2: popupBtn2,
    PopupBtnList: popupBtnList,
    AdvancePayment: advancePayment,
    OrdererSelect: ordererSelect,
    CustomerManagement: customerManagement,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
.non-scroll {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.non-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
</style>


